import { useEffect as n } from "react";
import { useLocation as i } from "react-router-dom";
import { useAuth as r } from "../context/auth/index.js";
const c = () => {
  const { User: e } = r(), t = i();
  return n(() => {
    var o;
    e && ((o = e.Pendo) != null && o.Enabled) && window.pendo && window.pendo.initialize({
      visitor: {
        id: e.Pendo.VisitorId,
        entitlement: e.Pendo.VisitorEntitlement,
        app: e.Pendo.VisitorApp,
        environment: e.Pendo.VisitorEnvironment,
        version: e.Pendo.VisitorVersion,
        role: e.Pendo.VisitorRole,
        "organisation name": e.Pendo.VisitorOrgName,
        "organisation type": e.Pendo.VisitorOrgType,
        state: e.Pendo.VisitorState,
        features: e.Pendo.VisitorFeatures,
        "feature set": e.Pendo.VisitorFeatureSet
      },
      account: {
        id: e.Pendo.AccountId,
        name: e.Pendo.AccountName,
        state: e.Pendo.AccountState,
        category: e.Pendo.AccountCategory
      }
    });
  }, [t.pathname, e]), null;
};
export {
  c as PendoInitializer
};
//# sourceMappingURL=pendo.js.map
